import Logo from '../../../primitives/Logo';
import { type ErrorPageStrings } from '../strings';

export function ErrorContent({
  baseUrl,
  resourcesUrl,
  statusLogoPng,
  strings,
}: {
  baseUrl: string;
  resourcesUrl: string;
  statusLogoPng: string;
  strings: ErrorPageStrings;
}) {
  return (
    <>
      <div className="textSection" data-testid="errorContent">
        <img
          alt={strings.internalServerError}
          className="mobileImage"
          data-testid="mobileErrorImage"
          src={`${resourcesUrl}/assets/img/${statusLogoPng}`}
        />
        <Logo resourcesUrl={resourcesUrl} />
        <div className="oops">{strings.header}!</div>
        <p className="text">{strings.description}.</p>
        <a className="homepage" href={baseUrl}>
          {strings.mainCta}
        </a>
        <p className="text">{strings.supportText}?</p>
        <div className="buttonSection">
          <a href={`${baseUrl}/${strings.freeBetsCtaUrl}`}>{strings.freeBetsCtaText}</a>
          <a href={`${baseUrl}/${strings.picksCtaUrl}`}>{strings.picksCtaText}</a>
          <a href={`${baseUrl}/${strings.bettingGuidesCtaUrl}`}>{strings.bettingGuidesCtaText}</a>
        </div>
      </div>
      <img
        alt={strings.internalServerError}
        className="desktopImage"
        data-testid="desktopErrorImage"
        src={`${resourcesUrl}/assets/img/${statusLogoPng}`}
      />
    </>
  );
}
